import { useTranslation } from 'react-i18next';
import { Window } from 'components/shared/window/window';
import { Board } from './Board';

export const SingleBoardWindow = (props) => {
  const { t } = useTranslation();
  return <Window header={t('windows.Количество свободных мест')} content={Board} width="440px" {...props.data} />;
};
